import { style } from "framer-motion/client";
import { ChevronRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const BreadCrumb = ({ items = [], children , instituition, marginBottom="3.7rem",country}) => {
 
  return (
    <Row>
      <Col xs={12}>
        <div className="page-title-box d-flex align-items-center justify-content-between " style={{marginTop:"1.5rem", marginBottom:marginBottom}}>

          {/* LEFT SIDE – Breadcrumb List */}
          <div className="page-title-left">
            <ol className="breadcrumb d-flex align-items-center m-0">

              {items.map((item, index) => (
                <React.Fragment key={index}>
                  
                  {/* Breadcrumb item */}
                  <li
                    className={`breadcrumb-item ${
                      index === items.length - 1 ? "active" : ""
                    }`}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {item.link ? (
                      <Link to={item.link} className="breadCrumb-text text-decoration-none"  style={{ color: country ? "#ffffffb4" : "#aca4a4ff" }}>{item.title}</Link>
                    ) : item.onClick ? (
                      <button
                        onClick={item.onClick}
                        className="btn btn-link p-0"
                        style={{ textDecoration: "none" }}
                      >
                        {item.title}
                      </button>
                    ) : (
                      <span className=" breadCrumb-text" style={instituition ? { color: "#fff" } : {color:"#000"}}>{item.title} </span>
                    )}
                  </li>

                  {/* Divider */}
                  {index < items.length - 1 && (
                    <span className="mx-2"><ChevronRight size={12} color="darkgray" className="mb-1"/></span>
                  )}

                </React.Fragment>
              ))}

            </ol>
          </div>

          {/* RIGHT SIDE – Extra Actions */}
          <div className="page-title-right  d-flex align-items-center">
            {children}
          </div>

        </div>
      </Col>
    </Row>
  );
};

export default BreadCrumb;
